import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Single } from "../sites/";
import { Lead } from "@cs125/gatsby-theme-cs125/src/material-ui";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = Single;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@cs125/mace"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/v/@cs125/mace",
          "alt": "npm"
        }}></img></a>{`
`}<img parentName="p" {...{
        "src": "https://img.shields.io/docker/v/cs125/mace?color=green&label=Docker&sort=date",
        "alt": "Docker Image Version (latest by date)"
      }}></img>{`
`}<a parentName="p" {...{
        "href": "https://opensource.org/licenses/MIT"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/badge/License-MIT-yellow.svg",
          "alt": "License: MIT"
        }}></img></a></p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "metastring": "id=install",
        "id": "install"
      }}>{`npm i @cs125/mace # client
docker pull cs125/mace # server
`}</code></pre>
    <Lead mdxType="Lead">
      <p>{`Client and server support for saving and synchonizing Ace editor contents.`}</p>
    </Lead>
    <h2>{`Use`}</h2>
    <p>{`Visit the `}<a parentName="p" {...{
        "href": "https://github.com/cs125-illinois/mace"
      }}>{`documentation here`}</a>{`.`}</p>
    <h2>{`Demo`}</h2>
    <p>{`The contents of the following editors will be synchronized via a backend server.
If you are logged in, they will also be saved across devices and browsers.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java",
        "metastring": "id=demo",
        "id": "demo"
      }}>{`System.out.println("Playgrounds rock!");
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-java",
        "metastring": "id=demo",
        "id": "demo"
      }}>{`System.out.println("Playgrounds rock!");
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      